import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { CP_ICONS } from '../../shared/icons';
import { BODY, H2, LEAD, SECTION_INNER, SECTION_PAD, TEXT_LINK } from '../../shared/ui';
import { FAQ_GROUPS } from './faq-v3.data';

@Component({
  selector: 'app-faq-v3',
  standalone: true,
  imports: [NgIcon, RouterLink],
  viewProviders: [provideIcons(CP_ICONS)],
  templateUrl: './faq-v3.component.html',
})
export class FaqV3Component {
  readonly inner = SECTION_INNER;
  readonly h2 = H2;
  readonly lead = LEAD;
  readonly body = BODY;
  readonly pad = SECTION_PAD;
  readonly textLink = TEXT_LINK;
  readonly groups = FAQ_GROUPS;
}
